<template>
  <div class="dataTemplate">
    <el-tabs class="dataTemplate-tabs" v-model="active" type="card" @tab-click="handleClick">
      <el-tab-pane :label="versionName" name="1">
        <el-transfer filterable :filter-method="filterMethod" filter-placeholder="请输入数据源名称" :titles="['可选数据源', '已选数据源']" v-model="selectedValue" :data="data" @change="changeData">
        </el-transfer>
        <el-button class="transfer_btn" type="primary" size="small" @click="handleSubmit()">确 定</el-button>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
export default {
  name: 'dataTemplate',
  data () {
    return {
      active: '1',
      versionName: '',
      data: [], // 数据模板列表
      selectedValue: [], // 选中值
      dataTemplate: [] // 存入数据模板列表
    }
  },
  created () {
    // this.getDataTemplateList()
  },
  mounted () {},
  methods: {
    filterMethod (query, item) {
      return item.label.indexOf(query) > -1
    },
    // 选值发生改变
    changeData () {
      // console.log(this.selectedValue)
    },
    // tab切换
    handleClick (v) {
      // console.log(v)
    },
    // 获取数据模板列表
    getDataTemplateList () {
      this.$http.get(this.API.dataTemplateList).then((res) => {
        let data = res.data
        if (data.code === 200) {
          // console.log(data.data)
          // 存入全部数据
          this.dataTemplate = data.data
          let dataTemplate = []
          let arr = data.data
          arr.forEach((ele, index) => {
            dataTemplate.push({
              key: ele.name,
              label: ele.name
            })
          })
          this.data = dataTemplate
          // console.log(this.data)
        }
      })
    },
    // 选中的值
    selectedData (versionName) {
      this.$http
        .get(this.API.selectedDataTemplateList, {
          params: {
            versionName: versionName
          }
        })
        .then((res) => {
          let data = res.data
          if (data.code === 200) {
            // console.log(data.data)
            let arr = data.data
            let selectedValue = []
            arr.forEach((ele) => {
              selectedValue.push(ele.dataName)
            })
            this.selectedValue = selectedValue
          }
        })
    },
    // 确定
    handleSubmit () {
      let data = {}
      let list = []
      console.log(this.selectedValue)
      if (this.selectedValue.length > 0) {
        let arr = this.filterByName(this.dataTemplate, this.selectedValue)
        // console.log(arr)
        arr.forEach((ele) => {
          list.push({
            dataId: ele.id,
            dataName: ele.name,
            dataCode: ele.code,
            versionName: this.versionName
          })
        })
        data.versionName = this.versionName
        data.list = list
      } else {
        data.versionName = this.versionName
        data.list = []
      }
      // console.log(data)
      this.$http.post(this.API.saveDataMapping, data).then((res) => {
        let data = res.data
        if (data.code === 200) {
          this.$message.success('修改成功！')
        } else {
          this.$message.error('接口调用失败！')
        }
      })
    },
    // 筛选出选中其他数据
    filterByName (aim, nameArr) {
      let result = []
      for (let i = 0; i < nameArr.length; i++) {
        result.push(aim.find((item) => item.name === nameArr[i]))
      }
      return result
    }
  }
}
</script>
<style lang="less" scoped>
.dataTemplate {
  // Tabs 标签页-覆盖
  .dataTemplate-tabs {
    /deep/.el-tabs__item {
      border: none !important;
      border-right: 1px solid #eee !important;
    }
    /deep/.el-tabs__active-bar {
      height: 2px !important;
    }
    /deep/.el-tabs__item.is-active {
      background-color: #fff !important;
      color: #409eff !important;
      border-bottom-color: #fff;
    }
    /deep/.el-tabs__item.is-top:nth-child(2) {
      border-left: 1px solid #eee;
      border-top-left-radius: 0px !important;
      border-bottom-left-radius: 0px !important;
      padding-left: 20px !important;
    }
    /deep/.el-tabs__item.is-top:last-child {
      border-top-right-radius: 0px !important;
      border-bottom-right-radius: 0px !important;
      padding-right: 20px !important;
      border-right: none !important;
    }
    /deep/.el-tabs__nav-wrap::after {
      height: 2px !important;
    }
    /deep/.el-tabs__nav-scroll {
      text-align: left !important;
    }
    /deep/.el-tabs__nav {
      float: left !important;
    }
    /* Transfer 穿梭框-覆盖 */
    /deep/ .el-transfer-panel {
      width: 270px;
    }
    /deep/ .el-transfer-panel__body {
      height: 380px;
    }
    /deep/ .el-transfer-panel__list.is-filterable {
      height: 328px;
    }
    // 按钮
    .transfer_btn {
      margin: 10px 0 0 653px;
    }
  }
}
</style>
